"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsDialog = void 0;
var _components = require("@ori-ui/components");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _logger = require("../../logger");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/no-danger -- X */

const TermsAndConditionsDialog = ({
  isOpen,
  onClose,
  termId
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const handleClose = (0, _react.useCallback)(() => onClose(undefined), [onClose]);
  const swrOptions = {
    ..._checkoutUtils.errorHandlingSwrOptions,
    enabled: true,
    onSuccess: () => (0, _logger.logDebug)('useGetTenantTermHtml() hook finished successfully.')
  };
  const {
    data: term
  } = (0, _staticApiClientReact.useGetTenantTermHtml)(tenant, termId, {
    swr: swrOptions
  });
  if (!term) {
    return null;
  }
  const {
    body
  } = term;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
    open: isOpen,
    disablePortal: false,
    onClose: handleClose,
    children: body ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: body
      }
    }) : undefined
  });
};
exports.TermsAndConditionsDialog = TermsAndConditionsDialog;